import { render, staticRenderFns } from "./quesInstru11.vue?vue&type=template&id=40edbacc"
import script from "./quesInstru11.vue?vue&type=script&lang=js"
export * from "./quesInstru11.vue?vue&type=script&lang=js"
import style0 from "./quesInstru11.vue?vue&type=style&index=0&id=40edbacc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports